// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 374) return "static/chunks/374-25f1b46fe73a6d02.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"140":"1e78b08f","239":"86bc6427","863":"reg-login"}[chunkId] || chunkId) + "." + {"140":"2b271c22cbce880c","239":"47c9fa1bf0f577a4","553":"dea20a29ca447610","863":"8b855e1d87d3fc8f","905":"b9ebc955f720beea"}[chunkId] + ".js";
};